import type { FC } from "react"
import React from "react"

import { useTranslation } from "react-i18next"
import { useRecoilState, useRecoilValue } from "recoil"
import styled from "styled-components"

import { designRequestNotesState } from "~/containers/Proposal/state/design-request/use-design-request"
import { useProposalContext } from "~/containers/Proposal/state/proposal/proposal-context"
import { currentUserState } from "~/containers/Proposal/state/user/user-state"
import { Permission } from "~/graphql/client"
import { getPowurUrl } from "~/utils/getUrlForEnvironment"

import { DrawerContainer } from ".."
import { DrawerListItem, Notes } from "./Notes"
import { notesDrawerIsOpenState } from "../../state/view"

const TicketsItem = styled(DrawerListItem)`
  border-color: var(--blue);
  cursor: pointer;
  padding: 13px 25px;

  p {
    font-weight: 500;
    color: var(--blue);
  }
`

const NoteDrawer_Internal: FC = () => {
  const { t } = useTranslation()
  const { powurProjectId } = useProposalContext().local
  const powurTicketsUrl = powurProjectId
    ? `${getPowurUrl()}/projects/${powurProjectId}/tickets`
    : `${getPowurUrl()}/tickets/inbox`
  const [notesDrawerIsOpen, setNotesDrawerIsOpen] = useRecoilState(
    notesDrawerIsOpenState,
  )
  const { permissions } = useRecoilValue(currentUserState)

  const designRequestNotes = useRecoilValue(designRequestNotesState)

  React.useEffect(() => {
    const isDesignerUser = [
      Permission.vision_designer_user,
      Permission.designer_user,
      Permission.tier_2_vision_designer,
    ].some((role) => permissions.includes(role))

    if (isDesignerUser && designRequestNotes.length > 0) {
      setNotesDrawerIsOpen(true)
    }
  }, [designRequestNotes.length, setNotesDrawerIsOpen, permissions])

  return (
    <DrawerContainer
      isOpen={notesDrawerIsOpen}
      close={() => setNotesDrawerIsOpen(false)}
      title={t(`proposalDetails`)}
    >
      <Notes />
      <h3>{t(`tickets`)}</h3>
      <TicketsItem onClick={() => window.open(powurTicketsUrl, `_blank`)}>
        <p>{powurTicketsUrl}</p>
      </TicketsItem>
    </DrawerContainer>
  )
}

export const NoteDrawer = React.memo(NoteDrawer_Internal)
